import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { month: 'Jan', connexions: 150, actions: 450 },
  { month: 'Fév', connexions: 180, actions: 520 },
  { month: 'Mar', connexions: 220, actions: 650 },
  { month: 'Avr', connexions: 250, actions: 800 },
  { month: 'Mai', connexions: 280, actions: 950 },
  { month: 'Juin', connexions: 310, actions: 1100 },
];

export const UserActivityChart: React.FC = () => {
  return (
    <div className="h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line 
            name="Connexions" 
            type="monotone" 
            dataKey="connexions" 
            stroke="#0a8345" 
            strokeWidth={2}
          />
          <Line 
            name="Actions" 
            type="monotone" 
            dataKey="actions" 
            stroke="#4ade80" 
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};